import { DateHelper } from "@/Common/Helpers/DateHelper";
import { PatientAppointmentListItem } from "@/Common/Models/Appointments/PatientAppointmentListItem";
import { Encounter } from "@/Patient/Models/MedicalSummary/Encounter";
import { PatientPrescriptionItem } from "@/Patient/Models/Medication/PatientPrescriptionItem";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

class MedicalNoteHelper {
    public static getPrescriptiondIds(prescriptions: Immutable.List<PatientPrescriptionItem>, currentEncounterId: string): string[] {
        return prescriptions
            .toArray()
            .filter(x => x.EncounterId == currentEncounterId)
            .map(p => p.PrescriptionId);
    }

    public static getConsultationRequestIds(noteModel: IPatientMedicalNoteModel): string[] {
        return noteModel
            .get("ConsultationRequests")
            .map(p => p.ConsultationRequestId)
            .toArray();
    }

    public static getExamRequestIds(noteModel: IPatientMedicalNoteModel): string[] {
        return noteModel
            .get("Requests")
            .map(p => p.RequestId)
            .toArray();
    }

    public static getPatientFormsIds(noteModel: IPatientMedicalNoteModel): string[] {
        return noteModel
            .get("PatientForms")
            .map(p => p.Id)
            .toArray();
    }

    public static AutoLinkAppointmentToEncounter(encounter: Encounter, patientAppointmentList: PatientAppointmentListItem[], consultationDate: Date = null): string {
        const cancelledStateCodes = ["NOSHOW", "CANCELED", "CANCELLED BY PATIENT"];

        const appointments = patientAppointmentList.filter(x => !cancelledStateCodes.includes(x.Model.StateCode));
        let filteredAppointment = appointments.filter(x => DateHelper.formatDate(x.Model.StartDate, "YYYY/MM/DD") === DateHelper.formatDate(encounter.ConsultationDate, "YYYY/MM/DD"));
        if (consultationDate) {
            filteredAppointment = appointments.filter(x => DateHelper.formatDate(x.Model.StartDate, "YYYY/MM/DD") === DateHelper.formatDate(consultationDate, "YYYY/MM/DD"));
        }

        if (filteredAppointment.length <= 0)
            return null;

        // Only 1 Appointment for today
        if (filteredAppointment.length === 1)
            return filteredAppointment.firstOrDefault().Model.AppointmentId;

        const encounterEmployeeId = encounter.EncounterRelatedEmployees
            .sortByProperty(p => p.FirstContribution)
            .map(enc => enc.EmployeeId)
            .firstOrDefault();

        if (encounterEmployeeId != null) {
        // Same Employee single match
            const encounterEmployeeCalendarEvents = filteredAppointment
                .filter(p => p.Model.EmployeeAndRoomId?.contains(encounterEmployeeId.toLowerCase()));
            if (encounterEmployeeCalendarEvents.length === 1)
                return encounterEmployeeCalendarEvents.firstOrDefault().Model.AppointmentId;

            // Same Employee and Site single match
            const sameEmployeeSameSiteCalendarEvents = filteredAppointment
                .filter(p => p.Model.EmployeeAndRoomId?.contains(encounterEmployeeId.toLowerCase())
                && p.Model.SiteId == encounter.SiteId
                );
            if (sameEmployeeSameSiteCalendarEvents.length === 1)
                return sameEmployeeSameSiteCalendarEvents.firstOrDefault().Model.AppointmentId;
        }

        // Same Site single match
        const sameSiteCalendarEvents = filteredAppointment
            .filter(p => p.Model.SiteId == encounter.SiteId);
        if (sameSiteCalendarEvents.length === 1)
            return sameSiteCalendarEvents.firstOrDefault().Model.AppointmentId;

        return null;
    }
}

export { MedicalNoteHelper };
